import { Country, de_BetterDocRecommendationState } from "@/types/__generated__/union-types"

export const BETTER_DOC_ROUTE_PATH = "/admin/better-doc"

export const SESSION_ID_SEARCH_PARAMETER = "sessionId"

export const GRAPHQL_INT_MAXIMUM = 2_147_483_647

export const LOOKUP_IDENTIFIER_MAXIMUM_LENGTH = 100

export const LIST_PAGE_SIZE = 50

export const BODY_COLLAPSE_THRESHOLD_CHARACTERS = 100_000

export const EMPTY_VALUE_PLACEHOLDER = "-"

export const BETTER_DOC_TABS = ["sessions", "openAtBetterDoc", "exchanges", "testCases"] as const

export type BetterDocTab = (typeof BETTER_DOC_TABS)[number]

export const BETTER_DOC_OPEN_LIST_KINDS = ["recommended", "selected"] as const

export type BetterDocOpenListKind = (typeof BETTER_DOC_OPEN_LIST_KINDS)[number]

export const INSURANCE_COUNTRIES: ReadonlyArray<Country> = ["CH", "DE"]

export const DEFAULT_INSURANCE_COUNTRY: Country = "DE"

export const RECOMMENDED_BETTER_DOC_STATES: ReadonlyArray<de_BetterDocRecommendationState> = [
  "RECOMMENDED",
  "MEDIC_SELECTED",
  "MEDIC_CONFIRMED",
]

export const REFERRAL_SLIP_DEFAULT_DURATION_DAYS = 7
